module.exports = require('./assets/js/lib/react-responsive-image.build.js');
